// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4289":"e5a9d6a31a0168ea","6454":"908078f0a785876a"}[chunkId] + ".css";
};